/**
 * @file index.tsx
 *
 * @fileoverview Renders the matching score component.
 */
import CirclePercentage from '~/vcl/atoms/20-charts/01-circle-percentage';
import { useConfig } from '~/jobiqo/context/config';

export interface MatchingScoreProps {
  /**
   * The matching score.
   */
  matchingScore: any;
}

export default function MatchingScore({ matchingScore }: MatchingScoreProps) {
  const { getConfigByName } = useConfig();
  const TRANSPARENCY_MODE_SHOW_MATCHING_SCORE: boolean = !!getConfigByName(
    'show_matching_score',
  )?.value[0];

  if (!TRANSPARENCY_MODE_SHOW_MATCHING_SCORE || !matchingScore) {
    return null;
  }

  // We receive matchingScore in a percentage format (0-100), so we can use it
  // directly and just add percentage symbol for text usage.
  const percentageText = matchingScore.toFixed(0) + '%';

  return (
    <CirclePercentage
      percentage={matchingScore}
      text={percentageText}
      width="80px"
    />
  );
}

export { MatchingScore };
